import { StatusBar } from "expo-status-bar";
import { StyleSheet, Text, View } from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";

import Lottery from "./pages/Lottery";
import User from "./pages/User";
import Login from "./pages/Login";
import { UserContextProvider } from "./store/user-data-context";

const Stack = createNativeStackNavigator();
const Tab = createBottomTabNavigator();

function HomePage() {
  return (
    <Tab.Navigator
      screenOptions={{
        headerLeft: () => {},
        headerStyle: { backgroundColor: "papayawhip" },
        headerTintColor: "#FF4800",
        headerTitleStyle: {
          fontSize: 35,
        },
        tabBarLabelStyle: { fontSize: 15, color: "#9A6C3D" },
        tabBarStyle: { height: 65 },
        tabBarActiveBackgroundColor: "#F0E7D8",
      }}
    >
      <Tab.Screen
        name="HomePage"
        component={Lottery}
        options={{
          title: "尊師活動抽扭蛋",
          tabBarIcon: () => (
            <MaterialCommunityIcons
              name="egg-easter"
              size={30}
              color="#9A6C3D"
            />
          ),
        }}
      />
      <Tab.Screen
        name="UserPage"
        component={User}
        options={{
          title: "個人資訊",
          tabBarIcon: () => (
            <FontAwesome name="id-card-o" size={30} color="#9A6C3D" />
          ),
        }}
      />
    </Tab.Navigator>
  );
}

export default function App() {
  return (
    <UserContextProvider>
      <NavigationContainer>
        <Stack.Navigator
          screenOptions={{
            headerLeft: () => {},
            headerStyle: { backgroundColor: "papayawhip" },
            headerTintColor: "#FF4800",
            headerTitleStyle: {
              fontSize: 20,
            },
          }}
        >
          <Stack.Screen name="Login" component={Login} presentation="modal" />
          <Stack.Screen
            name="Home"
            component={HomePage}
            options={{ headerShown: false }}
          />
        </Stack.Navigator>
      </NavigationContainer>
    </UserContextProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
});
